import React, { useState } from "react"

import LodgeItemModal from "~components/pages/outfitter/lodgings/lodge-item-modal"
import type { OutfitterLodgingFieldsFragment } from "~graphql/generated/graphql"
import LodgeImageCard from "~components/shared/todo-lib-react-components/image-card/lodge-image-card"
import SimpleGrid from "~components/shared/todo-lib-react-components/simple-grid"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly lodgings: OutfitterLodgingFieldsFragment[]
}

// TODO: move this outside of outfitter and power with lodgings collection
export default function LodgeList({ lodgings }: Props) {
    const [isOpen, setIsOpen] = useState(false)
    const [selectedLodging, setSelectedLodging] =
        useState<OutfitterLodgingFieldsFragment>()

    const onOpen = (lodging: OutfitterLodgingFieldsFragment) => {
        setIsOpen(true)
        setSelectedLodging(lodging)
    }

    const onClose = () => {
        setIsOpen(false)
        setSelectedLodging(undefined)
    }

    return (
        <>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }}>
                {lodgings.map((lodging) => (
                    <Box key={lodging.id}>
                        <LodgeImageCard
                            lodging={lodging}
                            handleClick={onOpen}
                        />
                    </Box>
                ))}
            </SimpleGrid>
            {selectedLodging && (
                <LodgeItemModal
                    isOpen={isOpen}
                    onClose={onClose}
                    lodging={selectedLodging}
                />
            )}
        </>
    )
}
